<template>
  <Transition name="fade">
    <div class="notificationHelperContainer"
         v-show="mustShow && numberOfNoticationForMe>0">
      <div class="buttonHelperNotification"
           @click="showMeTheNotification">
        {{ this.$tc('notification.newNotification', numberOfNoticationForMe, { number: numberOfNoticationForMe }) }}
        <w-icon icon="chevron-right" class="chevron" size="small"/>
      </div>
    </div>
  </Transition>
</template>

<script lang="ts">
import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {Notification} from '@/store/myNotifications/myNotificationModel';
import mobileDetect from 'mobile-device-detect';
import UserAvatar from '@/components/user/UserAvatar.vue';
import WIcon from '@/components/wrapper/w-icon.vue';
import WToolTip from '@/components/wrapper/w-toolTip.vue';
import store from '@/store';
import {READ_NOTIFICATIONS} from '@/store/myNotifications/myNotificationsAction';
import WButton from '@/components/wrapper/w-button.vue';
import {SEEK_PLAYER} from '@/store/timeLine/timeLineAction';
import {COMMENT_TO_REPLY, GetCommentParams, LIST_COMMENT, OPEN_PANEL_REPLY} from '@/store/comment/commentAction';


@Component({
  components: {WButton, WToolTip, WIcon, UserAvatar},
})
export default class NotificationWeetHelper extends Vue {

  private isMobile: boolean = mobileDetect.isMobile;
  private mustShow: boolean = false;
  @Prop()
  private weetID!: string;

  private startAutoRefresh: boolean = false;


  public mounted() {
    this.mustShow = true;
    // we start the auto refresh 2 secondes after the loading button
    // need if comment is zero at start
    setTimeout(() => {
      this.startAutoRefresh = true;
    }, 2000);
  }

  get numberOfComment(): number {
    return store.getters.getTotalOfComment;
  }

  get numberOfNoticationForMe(): number {
    return this.notificationUnreadForMe.length;
  }

  public showMeTheNotification() {
    if (this.notificationUnreadForMe.length <= 0) {
      return;
    }
    const notif = this.notificationUnreadForMe[0];

    if (notif.replyToCommentID) {
      store.dispatch(COMMENT_TO_REPLY, notif.replyToCommentID);
      store.dispatch(OPEN_PANEL_REPLY, notif.commentID);
    } else if (notif.commentID) {
      store.dispatch(COMMENT_TO_REPLY, notif.commentID);
      store.dispatch(OPEN_PANEL_REPLY, notif.commentID);
    }

    if (notif.time) {
      store.dispatch(SEEK_PLAYER, notif.time);
    }
    // we aquit the notification when we click on the update button
    setTimeout(() => {
      store.dispatch(READ_NOTIFICATIONS, [notif]);
    }, 500);
  }

  get notificationUnreadForMe(): Notification[] {
    const notifs: Notification[] = [];
    for (const notification of store.getters.getWeetTypeUnreadTimelineNotification) {
      if (notification.weetID === this.weetID) {
        notifs.push(notification);
      }
    }
    // we reverse the list
    return notifs.reverse();
  }

  @Watch('numberOfNoticationForMe')
  private refrehComment(now, prev) {
    // if new notification we reload the comment to get new comment
    if (this.startAutoRefresh && now > prev) {
      const paramsGetComment = new GetCommentParams(this.weetID);
      store.dispatch(LIST_COMMENT, paramsGetComment);
    }
  }

  @Watch('numberOfComment')
  private updateNumberOfCOmment() {
    this.startAutoRefresh = true;
  }

}
</script>

<style scoped lang="scss">
@import "@/scss/shadows.scss";
@import '@/scss/gridBreakPoint.scss';

.notificationHelperContainer {
  display: flex;
  animation-duration: 0.5s;
  margin-top: 8px;
  margin-bottom: 0px;
  transition: transform 0.2s ease;

  .buttonHelperNotification {
    display: flex;
    cursor: pointer;
    background: var(--primary);
    font-size: 14px;
    color: white;
    justify-content: center;
    width: 100%;
    font-weight: 600;
    padding-left: 16px;
    padding-top: 2px;
    padding-bottom: 2px;
    padding-right: 8px;
    border-radius: 16px;
    align-items: center;

    .chevron {

    }
  }

  &:hover {
    transform: scale(1.02);
  }

}
</style>
